import classnames from 'classnames';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIsSmallAndAbove } from '../../hooks/mediaQueries';
import Button from '@aoworld-aotech/components-react/lib/Button';
import Card from '@aoworld-aotech/components-react/lib/Card';
import {
	getLister,
	updateDismissFiltersUrl,
} from '../../actions/lister-actions';

export const NoResultsCard = () => {
	const { resetAllUrl } = useSelector((state) => state);

	const isSmallAndAbove = useIsSmallAndAbove();

	const dispatch = useDispatch();

	const clearFiltersFunction = (evt) => {
		evt.preventDefault();
		dispatch(
			getLister(resetAllUrl, {
				type: '',
				trackHistory: true,
			})
		);
		dispatch(updateDismissFiltersUrl(resetAllUrl));
	};

	return (
		<Card
			data-testid="no-results-card"
			className={classnames(
				'bg-white border-gray flex-col text-center',
				{ 'm-3 mb-64': !isSmallAndAbove },
				'p-20 lg:p-20'
			)}
			style={{
				backgroundImage: isSmallAndAbove
					? `url("https://media.ao.com/lister/assets/images/no-results-page/noresults-bg.png")`
					: `url("https://media.ao.com/lister/assets/images/no-results-page/noresults-bg-mobile_2x.png")`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: `right -100px bottom`,
			}}>
			<h4 className="text-display-sm m-0">
				Sorry, we found no items matching your filters
			</h4>
			<Button className="mt-6" onClick={clearFiltersFunction}>
				Reset my filters
			</Button>
		</Card>
	);
};

export default NoResultsCard;
